module.exports = __webpack_public_path__ + "static/grecianIsleRules-move-min.6b4038bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/instructional/grecianIsleRules-move-min.jpg
// module id = 146
// module chunks = 66570062548345 213534597649335